import { Trans } from "@lingui/macro";

import { PageFailure } from "@/components/feedback/pages/page_failure";

export const ErrorUnknown = () => (
  <PageFailure
    errorMessage={<Trans>Update your browser to the latest version. </Trans>}
    title={<Trans>Something went wrong. Not to worry!</Trans>}
  />
);
